import React from 'react'
import { Box, Typography, Link, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CloseIcon, WarningIcon } from '../../eid-icons'
import WarningImageSvg from './Resources/warning-modal-background-image.svg'
import { ButtonV2 } from 'packages/eid-ui'
import config from 'config'

const WarningPaper = styled(Box)(({ theme }) => ({
    width: '100%',
    borderRadius: '0.5rem',
    maxHeight: '29.6rem',
    maxWidth: '60rem',
    '&:focus': {
        outline: 'none',
    },
    [theme.breakpoints.down('md')]: {
        maxWidth: '35rem',
    },
}))

const WarningHeader = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 2.5rem',
    backgroundColor: '#ff5e65',
    minHeight: '4rem',
})

const WarningContent = styled(Box)(({ theme }) => ({
    backgroundColor: '#ffffff',
    backgroundImage: `url(${
        config.APP_SUBPATH ? config.APP_SUBPATH + '/' : ''
    }${WarningImageSvg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left bottom',
    padding: '2.5rem',
}))

const WarningTitle = styled(Typography)({
    fontSize: '1.8rem',
    color: '#ffffff',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    paddingRight: '1rem',
})

const WarningDescription = styled(Typography)({
    color: '#282828',
    fontSize: '1.6rem',
})

const ActionArea = styled(Box)({
    display: 'flex',
    marginTop: '2rem',
})

const buttonStyles = {
    minWidth: '6rem',
    padding: '0 0.6rem',
    width: '100%',
}

const WarningPrompt = ({
    title,
    description,
    proceed,
    proceeding,
    cancel,
    yesLabel,
    noLabel,
    disableProceedButton,
    children,
}) => {
    const { t } = useTranslation()

    return (
        <WarningPaper>
            <WarningHeader>
                <WarningTitle id="transition-modal-title">{title}</WarningTitle>
                <Link
                    component="button"
                    onClick={cancel}
                    aria-label="Close"
                >
                    <CloseIcon color="#ffffff" />
                </Link>
            </WarningHeader>
            <WarningContent>
                <Box display="flex">
                    <Box sx={{ paddingTop: '0.5rem' }}>
                        <WarningIcon color="#FF5E65" />
                    </Box>
                    <Box maxWidth="35rem" marginLeft="6rem" marginRight="6rem">
                        <WarningDescription id="transition-modal-description">
                            {description}
                        </WarningDescription>
                        {children}
                        <ActionArea>
                            <Box marginRight="1.5rem">
                                <ButtonV2
                                    label={noLabel}
                                    border="solid 1px #8b909a"
                                    borderRadius="0.5rem"
                                    fontColor="#8b909a"
                                    fontSize="1.6rem"
                                    height="4rem"
                                    onClick={cancel}
                                    style={buttonStyles}
                                />
                            </Box>
                            <Box marginRight="1.5rem">
                                <ButtonV2
                                    loading={proceeding}
                                    label={yesLabel}
                                    bgColor="#ff5e65"
                                    fontColor="#ffffff"
                                    fontSize="1.6rem"
                                    borderRadius="0.5rem"
                                    height="4rem"
                                    onClick={proceed}
                                    style={buttonStyles}
                                    disabled={disableProceedButton}
                                />
                            </Box>
                        </ActionArea>
                    </Box>
                </Box>
            </WarningContent>
        </WarningPaper>
    )
}

export default WarningPrompt
